import classNames from 'classnames';
import React from 'react';

import { Menu, Space } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { useOrganizationMenuByAlias } from '../../../../hooks/organizations';

import styles from './organization-menu.module.scss';

interface IProps {
  organizationAlias: string;
}

export const OrganizationMenu: React.FC<IProps> = ({ organizationAlias }) => {
  const isMobile = useIsMobile();
  const menu = useOrganizationMenuByAlias(organizationAlias);

  if (!menu?.length) return null;

  return (
    <Space size={20} className={classNames(styles.tabs, 'h-mt-20')} wrap={!isMobile}>
      {
        // @ts-ignore
        menu.map((item) => (
          <a
            href={item.href}
            target={'_self'}
            className={classNames(styles.tab, {
              [styles.active]: item.href?.includes('mag/') || item.href?.includes('novosti/'),
              [styles.link]: item.isLink,
            })}
            rel="noreferrer"
          >
            {item.label}
            {item.children?.length && (
              <div className={styles.subMenu}>
                <Menu>
                  {item.children.map((elem) => (
                    <Menu.Item>
                      <a href={elem.href} target={'_self'} className={styles.subLink} rel="noreferrer">
                        {elem.label}
                      </a>
                    </Menu.Item>
                  ))}
                </Menu>
              </div>
            )}
          </a>
        ))
      }
    </Space>
  );
};
